<script>
import ShowService from './../services/show-service'
import modalService from '@/services/modal-service'

export default {
    props: {
        resource: {
            type: [Object, Array],
            default: () => {},
        },
        icon: {
            type: Boolean,
            default: false,
        },
        /**
         * Use circular icon button style (new design)
         */
        circular: {
            type: Boolean,
            default: false,
        },
        /**
         * Size of the circular button: 'small' (40px), 'medium' (56px), 'large' (65px)
         */
        size: {
            type: String,
            default: 'medium',
            validator: value => ['small', 'medium', 'large'].includes(value),
        },
        type: {
            type: String,
            default: 'primary', // tag, primary, primaryFlat, secondary, transparent, tagSecondary, facebook, twitter, highlight, tagBlack, black, nadir, blue, follow
        },
        playlist: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        playback() {
            return this.$store.state.playback
        },
        loggedIn() {
            return this.$store.getters['auth/loggedIn']
        },
        playing() {
            return (
                (this.playback.status === 'playing' || this.playback.status === 'loading') &&
                ((this.playback.resource &&
                    this.resource &&
                    this.playback.resource.type === this.resource.type &&
                    this.playback.resource.id === this.resource.id) ||
                    (this.playlist && this.$store.state.queue.playlistId === this.playlist.id))
            )
        },
        currentIcon() {
            if (this.icon) {
                return this.playing ? 'pause' : 'play_arrow'
            }
            return ''
        },
        circularIcon() {
            return this.playing ? 'pause-circle' : 'play-circle'
        },
        isMixLoaded() {
            return this.$store.state.playback.resource && this.resource.id === this.$store.state.playback.resource.id
        },
        buttonTitle() {
            return this.playing ? 'Pause' : 'Play'
        },
    },
    methods: {
        handleClick() {
            if (this.playlist) return

            if (this.isMixLoaded) return this.$queueService.pause()

            if (this.playing) {
                this.$queueService.pause()
            } else if (this.resource && this.resource.type && this.resource.type === 'channel') {
                if (!this.loggedIn) {
                    modalService.show('AUTH_REQUIRED_FOR_PLAYBACK')
                    return
                }
                this.$queueService.playRadioChannel(this.resource.id).catch(e => {
                    this.$store.dispatch('appearance/handleNotification', { message: e.message, type: 'warning' })
                })
            } else {
                if (!this.loggedIn) {
                    modalService.show('AUTH_REQUIRED_FOR_PLAYBACK')
                    return
                }
                this.$queueService
                    .playMix(this.resource)
                    .then(data => {
                        this.increaseReach(this.resource.show_id.id)
                    })
                    .catch(e => {
                        this.$store.dispatch('appearance/handleNotification', { message: e.message, type: 'warning' })
                    })
            }
        },
        increaseReach(id) {
            // const id = this.resource.id

            ShowService().increaseSessionReach(id)
            this.$store.dispatch('shows/increaseReach')
        },
    },
}
</script>

<template>
    <button
        v-if="circular"
        :class="[
            $style.circularButton,
            $style[size],
            (resource && resource.id) || (playlist && playlist.id) ? '' : $style.inactive
        ]"
        :title="buttonTitle"
        :aria-label="buttonTitle"
        @click="handleClick"
    >
        <BaseIcon
            :name="circularIcon"
            :class="$style.circularIcon"
        />
    </button>
    <BaseButton
        v-else
        :icon="currentIcon"
        :button-type="type"
        :class="[(resource && resource.id) || (playlist && playlist.id) ? '' : $style.inactive]"
        @click="handleClick"
    >
        <slot>
            <span
                :class="$style.buttonTitle"
                :title="buttonTitle"
            >
                {{ buttonTitle }}
            </span>
        </slot>
    </BaseButton>
</template>

<style lang="scss" module>
@import '@design';

.inactive {
    pointer-events: none;
    opacity: 0.3;
    filter: grayscale(1);
}

.circularButton {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    color: $c-razzmatazz;
    cursor: pointer;
    background: transparent;
    border: none;
    border-radius: 50%;
    transition: transform 0.15s ease-in-out, opacity 0.15s ease-in-out;

    &:hover {
        transform: scale(1.05);
    }

    &:active {
        transform: scale(0.95);
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid $c-razzmatazz;
        outline-offset: 2px;
    }
}

.circularIcon {
    display: block;
    width: 100%;
    height: 100%;
}

// Size variants
.small {
    width: 40px;
    height: 40px;
}

.medium {
    width: 56px;
    height: 56px;
}

.large {
    width: 65px;
    height: 65px;
}
</style>
